import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { TooltipProvider } from "./components/ui/tooltip";
import { ToastProvider } from "./components/Toaster";
import "@fontsource-variable/atkinson-hyperlegible-next";
import "./index.css";
import { ApiError } from "./lib/api";

const queryClient = new QueryClient({
  // Retry once for network or server trouble; a 4xx (not found, not allowed) won't change on a second try.
  defaultOptions: { queries: { retry: (count, err) => count < 1 && !(err instanceof ApiError && err.status >= 400 && err.status < 500), refetchOnWindowFocus: false } },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ToastProvider>
          <RouterProvider router={router} context={{ queryClient }} />
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
